import React from "react";

const COLORS = {
  en_attente: "bg-[#E9C46A] text-black",
  en_cours: "bg-[#0A0A0A] text-white",
  en_route: "bg-blue-600 text-white",
  termine: "bg-[#2A9D8F] text-white",
  annule: "bg-neutral-300 text-neutral-700",
};

export const STATUS_LABELS = {
  en_attente: "En attente",
  en_cours: "En préparation",
  en_route: "En route",
  termine: "Terminé",
  annule: "Annulé",
};

const StatusBadge = ({ status, "data-testid": dataTestId }) => {
  const cls = COLORS[status] || "bg-neutral-200 text-black";
  return (
    <span
      data-testid={dataTestId || `status-badge-${status}`}
      className={`inline-block text-[11px] font-bold uppercase tracking-[0.15em] px-2.5 py-1 rounded-sm ${cls}`}
    >
      {STATUS_LABELS[status] || status}
    </span>
  );
};

export default StatusBadge;
